"use strict";
/*******************************************************************************

    Contains definition for the balance for one address

    Copyright:
        Copyright (c) 2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletBalance = void 0;
var Amount_1 = require("../common/Amount");
/**
 * Class that defines the balance for one address
 */
var WalletBalance = /** @class */ (function () {
    function WalletBalance(address, balance, spendable, frozen, locked, enable) {
        if (address === void 0) { address = ""; }
        if (balance === void 0) { balance = Amount_1.Amount.make(0); }
        if (spendable === void 0) { spendable = Amount_1.Amount.make(0); }
        if (frozen === void 0) { frozen = Amount_1.Amount.make(0); }
        if (locked === void 0) { locked = Amount_1.Amount.make(0); }
        if (enable === void 0) { enable = false; }
        this.address = address;
        this.balance = balance;
        this.spendable = spendable;
        this.frozen = frozen;
        this.locked = locked;
        this.enable = enable;
    }
    return WalletBalance;
}());
exports.WalletBalance = WalletBalance;
//# sourceMappingURL=WalletBalance.js.map